export const ruleUseListConfig = [
  {
    label: "自动阅卷",
    value: "自动阅卷",
    statusList: [
      { label: "通过", value: 1 },
      { label: "待定", value: 2 },
      { label: "拒绝", value: 3 }
    ],
    propName: "auditDesc"
  },
  {
    label: "AI推荐",
    value: "AI推荐",
    statusList: [
      { label: "不推荐", value: 10 },
      { label: "一般", value: 20 },
      { label: "推荐", value: 30 },
      { label: "非常推荐", value: 40 }
    ],
    propName: ""
  },
  { label: "打标签", value: "打标签", statusList: null, propName: "tagName" },
  {
    label: "自定义Moka成绩回传",
    value: "自定义Moka成绩回传",
    statusList: null,
    propName: "mokaCustomResult"
  },
  {
    label: "自定义MokaAI面试评估结果",
    value: "自定义MokaAI面试评估结果",
    statusList: null,
    propName: "mokaCustomResult"
  },
  {
    label: "自定义moka详情考试结果",
    value: "自定义moka详情考试结果",
    statusList: null,
    propName: "mokaCustomResult"
  },
  // { label: "自定义报告总分展示", value: "自定义报告总分展示", statusList: null, propName: "tagName" },
  {
    label: "报告评价",
    value: "报告评价",
    statusList: [
      { label: "优点", value: 1 },
      { label: "缺点", value: 2 },
      { label: "建议", value: 3 },
      { label: "中性", value: 4 }
    ],
    propName: "message"
  }
  // {
  //   label: "维度组评价",
  //   value: "维度组评价",
  //   statusList: [
  //     { label: "三档低", value: 1 },
  //     { label: "三档中", value: 2 },
  //     { label: "三档高", value: 3 },
  //     { label: "四档低", value: 4 },
  //     { label: "四档中", value: 5 },
  //     { label: "四档高", value: 6 },
  //     { label: "四档差", value: 7 }
  //   ],
  //   propName: "dimensionLevelDesc"
  // },
  // {
  //   label: "维度评价",
  //   value: "维度评价",
  //   statusList: [
  //     { label: "三档低", value: 1 },
  //     { label: "三档中", value: 2 },
  //     { label: "三档高", value: 3 },
  //     { label: "四档低", value: 4 },
  //     { label: "四档中", value: 5 },
  //     { label: "四档高", value: 6 },
  //     { label: "四档差", value: 7 }
  //   ],
  //   propName: "dimensionLevelDesc"
  // }
];

export const getRuleUseConfig = (type: string) => {
  switch (type) {
    case "自动阅卷":
      return ruleUseListConfig[0].statusList;
    case "AI推荐":
      return ruleUseListConfig[1].statusList;
    case "报告评价":
      return ruleUseListConfig[5].statusList;
    default:
      return [];
  }
};

// 根据规则应用类型获取码值
export const getRuleValueByRuleType = (row: any) => {
  switch (row.type) {
    case "自动阅卷":
      return getRuleStatusLabelByValue("自动阅卷", row.auditStatus);
    case "AI推荐":
      return getRuleStatusLabelByValue("AI推荐", row.aiRecommendStatus);
    case "报告评价":
      return getRuleStatusLabelByValue("报告评价", row.messageType);
    default:
      return "";
  }
};

export const getRuleStatusLabelByValue = (type: string, value: number) => {
  const list = getRuleUseConfig(type);
  return list?.find((item: any) => item?.value === value)?.label;
};

// 命中原因，
export const tagSentimentList = [
  { label: "无", value: 0 },
  { label: "正向", value: 1 },
  { label: "中性", value: 2 },
  { label: "负向", value: 3 }
];
